import * as React from 'react';

import { Rating } from './Rating';
import { SquareRatingProps } from './ElementTypeInterfaces';

export const SquareRating: React.FunctionComponent<SquareRatingProps> = (
  props
) => {
  return <Rating {...props} variant={'square'} />;
};

SquareRating.defaultProps = {
  count: 11,
  startFromZero: true,
};
